import { style } from '@vanilla-extract/css';

export const listItem = style({
  margin: 'var(--wt-list-item-spacing, 10px) 0px 0px 0px',
});
